import { resolveInterventionApprovalLetterFollowUp } from './interventionStatus';

// Callers supply plans already scoped to the current application.
export function pendingInterventionCompletions(plans, planId = null) {
  return (plans || []).filter(plan => !planId || String(plan.id) === String(planId))
    .flatMap(plan => (plan.interventions || []).map(item => ({ ...item, actionPlanId: item.actionPlanId || plan.id })))
    .filter(item => {
      if (item.isAppliedRevisionEvidence || item.metadata?.revisionApplication?.status === 'applied') return false;
      const followUp = resolveInterventionApprovalLetterFollowUp(item);
      return followUp.eligible && followUp.pendingLetter;
    });
}

export function approvedSourceForRevision(plans, revisionId) {
  if (!revisionId) return null;
  for (const plan of plans || []) {
    const evidence = (plan.appliedRevisionEvidence || []).find(item => String(item.id) === String(revisionId));
    const sourceId = evidence?.metadata?.revisionApplication?.appliedToInterventionId;
    const source = (plan.interventions || []).find(item =>
      (sourceId && String(item.id) === String(sourceId)) ||
      String(item.metadata?.lastAppliedRevision?.draftInterventionId || '') === String(revisionId));
    if (source && resolveInterventionApprovalLetterFollowUp(source).eligible) return source;
  }
  return null;
}
